import React, { useEffect, useState } from 'react';

import CommonService from '../../../../services/commonService';

const createMarkup = data => {
	return { __html: data };
};

const ThemeTwoAboutUs = props => {
	const operator = CommonService.getLocal('op');
	const [customStyle, setCustomStyle] = useState({});
	const [isCormar, setIsCormar] = useState(false);

	useEffect(() => {
		const shouldSetCormar = window.location.hostname.includes("cormar");
		if (shouldSetCormar !== isCormar) {
			setIsCormar(shouldSetCormar);
		}

		const operator = CommonService.getLocal('op');
		if (operator && operator.operator_name === 'biaggini') {
			setCustomStyle(prevStyle => ({
				...prevStyle,
				strongFontSize: '24px'
			}));
		}
	}, []);

	return (
		<div className="themes-theme-two-about-us new-container">
			<style>
				{`
          .themes-theme-two-about-us .about p strong {
            font-size: ${customStyle.strongFontSize || 'inherit'};
          }
        `}
			</style>
			<div
				dangerouslySetInnerHTML={createMarkup(
					props.operator && props.operator.about_us ? props.operator.about_us : '',
				)}
				className="lh-1-3 justify-text about"
				style={{
					flex: 1,
					background: isCormar ? "white" :
						props.operator &&
						props.operator.color_codes &&
						props.operator.color_codes.primary_color,
					color: operator && operator.operator_name === "santarosa" || operator && operator.operator_name === "buseslafit" ? "white" :
						props.operator &&
						props.operator.color_codes &&
						props.operator.color_codes.tertiary_text_color,
					marginTop: customStyle.marginTop,
					borderTopLeftRadius: props.operator.operator_name === 'santarosa' || operator && operator.operator_name === "buseslafit"  ? "10px" : '',
					borderTopRightRadius: props.operator.operator_name === 'santarosa' || operator && operator.operator_name === "buseslafit" ? "10px" : '',
				}}
			/>
		</div>
	);
};

export default ThemeTwoAboutUs;



// WEBPACK FOOTER //
// ./src/features/themes/ThemeTwo/common/ThemeTwoAboutUs.js